<template>
  <div class="osBody">
    <div class="osTree" v-show="IfShow === 0">
         <el-tree
     :data="osData"
     accordion
  :props="defaultProps"
  :load="loadNode"
  highlight-current
  lazy
  ref="tree"
  v-loading="loading" 
  @node-click="chooseNode"
        class="ElTree">
    </el-tree>
        <div class="TreeDiv" @click="TreeD">
          <img :src="ImgSrc" alt="" srcset="" style="width:100%;height:100%">
        </div>
    </div>
    <div class="osTreeOne" v-show="IfShow === 1">
       <div class="TreeDivOne" @click="TreeD">
          <img :src="ImgSrc" alt="" srcset="" style="width:100%;height:100%">
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paymentTree",
  data() {
    return {
      loading: true,
      osData: [],
      emigration:"已迁出业主",
      AllDate:"",
   defaultProps: { children: 'children', label: 'label', isLeaf:(data,node) =>{
       if(node.level===4){ return  true}   // 根据需要进行条件判断添加is-leaf类   return  true
    }},
   roomStatus:"",
                 ImgSrc:require('../../assets/images/zuo@3x.png'),
      TreeNum:1,
      IfShow:0,
    }
  },
  methods: {
    emigrationClick(){
      if(this.emigration=="已迁出业主"){
        this.emigration="未迁出业主"
        this.roomStatus="2";
        this.getUserOffice();

      }else if(this.emigration=="未迁出业主"){
        this.emigration="已迁出业主"
        this.roomStatus="4";
        this.getUserOffice();
        
      }
    },
            TreeD(){
      if(this.IfShow >= 1 ) {
        this.IfShow = 0
        this.ImgSrc=require('../../assets/images/zuo@3x.png')
      } else{
        this.IfShow ++
        this.ImgSrc=require('../../assets/images/shouhui@3x.png')
      }
    },
       loadNode(node, resolve) {
           if(node.data.children != null){
               return resolve(node.data.children);
           }else{
             if(node.data.children == null && node.data.orgId == null){
               if(node.data.roomId){
                         setTimeout(() => {
                            const data = [];
                            resolve(data);
                          }, 500);
               }else{
                  let obj = {
                    "floorId":node.data.id,
                    "roomStatus":this.roomStatus
                  }
                   this.$http.post(this.$requestUrl.GET_FLOOR_LIST,obj).then((res) => {
                     let data = res.data.data
                     if(data!=null){
                       for(let i = 0;i<data.length;i++){
                          if(data[i].roomId){
                                setTimeout(() => {
                                  for(let val of data){
                                      val.label = val.roomName+"|"+val.customerName
                                  }
                                  resolve(data);
                                }, 500);
                          }else{
                            return resolve()
                          }
                       }
                     }else{
                     
                     }
                   })
               }

             }else{
               return resolve()
             }
           }
      },
    chooseNode(data) {
      // console.log(data)
      this.$emit('paymentTree',data)
    },
    getUserOffice() {
      this.$http.get(this.$requestUrl.GET_FLOOR_TREE).then((res) => {
         if(res.data.code == 200){
          let data = res.data.data;
          this.osData = data
          this.loading=false
        }else{
          this.$message.error(data.msg)
          this.loading=false
        }
      }).catch(() => {
        this.loading=false
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
  },
  mounted() {
    this.getUserOffice();
  }
}
</script>


<style scoped lang="scss">
.osBody {
  height: 720px;
  float: left;
  margin-right:1% ;
  margin-top: -14px;
  .osTree{
    width: 220px;
    height: 720px;
    position: relative;
  }
  .osTreeOne{
    width: 20px;
    height: 720px;
    position: relative;
  }
}
.TreeDiv{
  width: 20px;
  height: 60px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  right: -17px;
}
.TreeDivOne{
    width: 25px;
  height: 70px;
  border-radius: 10px;
  z-index: 500;
  position: absolute;
  top: 45%;
  left:-3px;
}
.ElTree{
  z-index: 500;
  height: 720px;
    overflow-Y:scroll;
}
</style>